import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { Map } from "ol";
import React from "react";
import { useTranslation } from "react-i18next";
import { PortServiceTypeEnum } from "~/api/GeneratedApi";
import { PortServiceMapItem } from "../types/mapItems";
import { GenericPopup } from "./GenericPopup";

type Props = {
  map: Map;
} & (ClickProps | HoverProps);

type ClickProps = {
  clickData: PortServiceMapItem;
  hoverData?: PortServiceMapItem;
};

type HoverProps = {
  hoverData: PortServiceMapItem;
  clickData?: PortServiceMapItem;
};

export const PortServicePopup = ({
  hoverData,
  clickData,
  map,
}: Props): JSX.Element | null => {
  const { t } = useTranslation("port-services");
  const data = clickData ?? hoverData;

  if (!data) return null;
  const { name, description, availabilityInfo, portServiceType } = data;

  // Not sure if this is illegal
  const type = t(
    `service-type-enum-${PortServiceTypeEnum[portServiceType].toLowerCase()}`,
  );

  return (
    <GenericPopup
      map={map}
      clicked={!!clickData}
      avatarText={type[0]?.toUpperCase() ?? ""}
      title={`${t("port-service")} - ${name ?? ""}`}
      subheader={type ?? ""}
      contentProps={{
        style: { padding: 0, maxHeight: clickData ? 600 : undefined },
      }}
      headerProps={{
        style: {
          paddingBottom: clickData ? 0 : undefined,
        },
      }}
      content={
        <Box p={2}>
          <Typography variant="body2" align="left" noWrap>
            {`${t("name")}: ${name}`}
          </Typography>
          <Typography variant="body2" align="left" noWrap>
            {`${t("description")}: ${description}`}
          </Typography>
          <Typography variant="body2" align="left" noWrap>
            {`${t("availability-info")}: ${availabilityInfo}`}
          </Typography>
          <Typography variant="body2" align="left" noWrap>
            {`${t("service-type")}: ${type}`}
          </Typography>
        </Box>
      }
    />
  );
};
